import React from "react";
import { Table } from "react-bootstrap";

export default function NBOTableBackoffice({ nbos = [] }) {
  if (!nbos?.length) return <p>No NBO offers available.</p>;

  return (
    <div className="table-responsive">
      <Table bordered hover>
        <thead className="thead-light">
          <tr>
            <th>#</th>
            <th>Proposed Price (k€/MW)</th>
            <th>Contingences (%)</th>
            <th>Exclusivity</th>
            <th>Exclusivity (months)</th>
            <th>Transaction Structure</th>
            <th>Percent Acquired (%)</th>
            <th>Services Required</th>
            <th>Observations</th>
          </tr>
        </thead>
        <tbody>
          {nbos.map((nbo, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{nbo?.proposedPrice ?? "---"}</td>
              <td>{nbo?.contingences ?? "---"}</td>
              <td>{nbo?.exclusivity ? "Yes" : "No"}</td>
              <td>{nbo?.exclusivityMonths ?? "---"}</td>
              <td>{nbo?.acquiring ?? "---"}</td>
              <td>{nbo?.percentAc ?? "---"}</td>
              <td>
                {Object.entries(nbo?.serv || {})
                  .filter(([_, val]) => val)
                  .map(([key]) => key.toUpperCase())
                  .join(", ") || "---"}
              </td>
              <td>{nbo?.observations ?? "---"}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
